import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-ink-900 py-20" aria-labelledby="final-title" data-id="element-76" data-mp="19fgwq6fnfg8i">
      <div className="mx-auto max-w-3xl px-5" data-id="element-77" data-mp="15ddkvgp2i9mp">
        <div className="rounded-3xl border border-gold-500/35 bg-ink-800 px-6 py-10 sm:px-10" data-id="element-78" data-mp="15ckg2l9o5u77">
          <CountdownTimer label="El precio cierra en:" data-id="element-79" data-mp="1jbty7qhfqydt" />

          <div className="mt-9 text-center" data-id="element-80" data-mp="1eebm5r84g31l">
            <h2 id="final-title" className="font-display text-2xl uppercase text-cream sm:text-3xl" data-id="element-81" data-mp="1edipxk6sgvxp">
              MegaPack Reto 30 días fit
            </h2>
            <p className="mt-2 text-sm text-cream/65" data-id="element-82" data-mp="1o3bo9jhx7ek0">
              6 Tomos + 2 Bonos + Video Masterclass · Todos los niveles
            </p>
            <div className="mt-6 flex items-end justify-center gap-3" data-id="element-83" data-mp="2245xu5gpflk9">
              <span className="text-lg text-cream/40 line-through" data-id="element-84" data-mp="1x5b8eko8eyr6">$89.000</span>
              <span className="font-display text-5xl text-gold-500" data-id="element-85" data-mp="n5uma2yndpha">$19.990</span>
            </div>
          </div>

          <div className="mt-8" data-id="element-86" data-mp="s3w3sjgfdgqn">
            <CtaButton data-id="element-87" data-mp="s4xq5k2w5pno">Quiero mi MegaPack</CtaButton>
          </div>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-cream/55" data-id="element-88" data-mp="x2qus8ojqblu">
            <span className="inline-flex items-center gap-1.5" data-id="element-89" data-mp="123mwqgpc7nom">
              <LockIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-90" data-mp="16503qu461wx4" /> Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-91" data-mp="1b2i3btwamzsg">
              <ZapIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-92" data-mp="1fu9uo6n9x9jn" /> Acceso en 5 minutos
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="1ktwcyuhylfzb">
              <ShieldCheckIcon className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-94" data-mp="1kv7bofwjrxjk" /> Garantía 7
              días
            </span>
          </div>
          <p className="mt-3 text-center text-[11px] uppercase tracking-[0.16em] text-cream/40" data-id="element-95" data-mp="1tv2qqvt84cov">
            Mercado Pago — Tarjeta — Transferencia
          </p>
        </div>

        <div className="mt-14 text-center" data-id="element-96" data-mp="3lw45jjhxhic1">
          <p className="font-display text-2xl uppercase leading-tight text-cream sm:text-3xl" data-id="element-97" data-mp="3lxf9pkfacs3o">
            El próximo lunes puede ser diferente.
          </p>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-cream/70 sm:text-base" data-id="element-98" data-mp="3uw0od4hmzmz6">
            Tenés todo lo que necesitás para transformar tu cuerpo, tu energía y tu relación con la
            comida. La única pregunta es: ¿cuándo empezás?
          </p>
          <div className="mx-auto mt-8 max-w-md" data-id="element-99" data-mp="mggxud8coint">
            <CtaButton data-id="element-100" data-mp="mf5ycplxtx2i">Quiero mi MegaPack — $19.990</CtaButton>
          </div>
        </div>
      </div>
    </section>;
}